import script from "./documents-uploader-text.vue?vue&type=script&setup=true&lang=ts"
export * from "./documents-uploader-text.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__